"use strict";
/**
 *
 * @param value value may contain any letters
 * @param allowNegative use for negative and both positive
 * @param maxLength max length include digits , and decimals not include the sign
 * @param decimals max number of decimal
 * @returns price which contains 9 digits and 2 decimals
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatToDigitsStr = void 0;
const MINUS_SIGN = '-';
const DECIMAL_POINT = '.';
const formatToDigitsStr = (value, allowNegative, maxLength = 8, decimals = 2) => {
    const regex = new RegExp(allowNegative ? '[^0-9\\.-]' : '[^0-9\\.]', 'gi');
    if (allowNegative) {
        value = value[0] + value.substr(1).replace(MINUS_SIGN, '');
    }
    const indexOfDecimalPoint = value.indexOf(DECIMAL_POINT);
    if (indexOfDecimalPoint >= 0) {
        value =
            value.substr(0, indexOfDecimalPoint + 1) +
                value.substr(indexOfDecimalPoint + 1).replace(DECIMAL_POINT, '');
    }
    let onlyDigitValue = (value || '').replace(regex, '');
    const numberOfDecimals = indexOfDecimalPoint >= 0
        ? onlyDigitValue.substr(indexOfDecimalPoint + 1).length
        : 0;
    if (numberOfDecimals > decimals) {
        onlyDigitValue = onlyDigitValue.substring(0, onlyDigitValue.length - (numberOfDecimals - decimals));
    }
    if (decimals == 0) {
        onlyDigitValue = onlyDigitValue.replace(/\./g, '');
    }
    const isHavingMinus = onlyDigitValue[0] === MINUS_SIGN;
    return onlyDigitValue.substr(0, isHavingMinus ? maxLength + 1 : maxLength);
};
exports.formatToDigitsStr = formatToDigitsStr;
//# sourceMappingURL=formatToDigitsStr.js.map